export const FRICTION: number = 0.7; // Friction coefficient of space (0 = no friction, 1 = lots of friction).
